class WistiaVideo {
  constructor() {
    this.isTracking = false;
  }

  init() {
    this.tracking();
  }

  startTracking() {
    this.isTracking = true;

    this.tracking();
  }

  kill() {
    this.isTracking = false;

    this.tracking();
  }

  tracking() {
    window._wq = window._wq || [];

    let _this = this;
    window._wq.push(function (W) {
      W.consent(_this.isTracking);
    });
  }
}

export default WistiaVideo;
